import * as React from 'react';
import styled from 'styled-components';
import { Skeleton } from '../skeleton/Skeleton';

const Container = styled.div`
  display: grid;
  width: 100%;
`;

type DataEntrySkeletonProps = {
  rows?: number;
};

export const DataEntryTableSkeleton = ({ rows }: DataEntrySkeletonProps): React.ReactElement => (
  <Container>
    <Skeleton height={28} />
    {Array.from({ length: rows || 5 }).map((_, index) => (
      <Skeleton key={index} height={36.5} />
    ))}
  </Container>
);
